__turbopack_context__.v({
  "bottomAlignedView": "ContactModal-module-scss-module__OY2P1W__bottomAlignedView",
  "contactModalBody": "ContactModal-module-scss-module__OY2P1W__contactModalBody",
  "contactModalRoot": "ContactModal-module-scss-module__OY2P1W__contactModalRoot",
});
